import helperService from '../../../services/helper.service';
import { DynamicIcon } from '../../atoms/dynamic-icon/dynamic-icon';
import styles from './page-info.module.scss';

interface PageInfoProps {
  icon?: any;
  title: string;
}

function PageInfo({ icon, title }: Required<PageInfoProps>) {
  return (
    <div className={styles.pageInfo}>
      <DynamicIcon iconName={icon} className={styles.icon} />
      <div className={styles.title}>
        {title ? helperService.capitalizeFirstLowercaseRest(title) : '...'}
      </div>
    </div>
  );
}

export default PageInfo;
